import './AddressUpdateThankYou.css';

export const AddressUpdateThankYou = () => {
  return (
    <div className="addressThankyouDiv">
      <div className="addressThankyouMessage">
          Address information successfully updated!
      </div>
    </div>
  );
}
